import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const Impressum = () => {
  const navigate = useNavigate();
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} className="bg-white/80 backdrop-blur-md rounded-3xl overflow-hidden shadow-lg p-8 md:p-12" data-id="element-267">
      <div className="mb-8" data-id="element-268">
        <motion.button onClick={() => navigate('/')} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gray-100 text-gray-800 hover:bg-gray-200 transition-colors duration-200" data-id="element-269">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-270" />
          <span data-id="element-271">Zurück</span>
        </motion.button>
      </div>
      <h1 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-272">Impressum</h1>
      <div className="space-y-8" data-id="element-273">
        <section data-id="element-274">
          <h2 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-275">
            Angaben gemäß § 5 TMG
          </h2>
          <div className="space-y-2" data-id="element-276">
            <p data-id="element-277">Nicolas Lehnert</p>
            <p data-id="element-278">Rheingasse 4</p>
            <p data-id="element-279">53113 Bonn</p>
            <p data-id="element-280">Deutschland</p>
          </div>
        </section>
        <section data-id="element-281">
          <h2 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-282">Kontakt</h2>
          <div className="space-y-2" data-id="element-283">
            <p data-id="element-284">Telefon: +49 (0) 123 456789</p>
            <p data-id="element-285">E-Mail: Nicolas.lehnert@outlook.de</p>
          </div>
        </section>
        <section data-id="element-286">
          <h2 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-287">
            Umsatzsteuer-ID
          </h2>
          <div className="space-y-2" data-id="element-288">
            <p data-id="element-289">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a
              Umsatzsteuergesetz:
            </p>
            <p data-id="element-290">DE123456789</p>
          </div>
        </section>
        <section data-id="element-291">
          <h2 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-292">
            Berufsbezeichnung und berufsrechtliche Regelungen
          </h2>
          <div className="space-y-2" data-id="element-293">
            <p data-id="element-294">Berufsbezeichnung: Videograf und Fotograf</p>
            <p data-id="element-295">Verliehen in: Deutschland</p>
            <p data-id="element-296">
              Es gelten folgende berufsrechtliche Regelungen: [Regelungen
              einfügen]
            </p>
          </div>
        </section>
        <section data-id="element-297">
          <h2 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-298">
            Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
          </h2>
          <div className="space-y-2" data-id="element-299">
            <p data-id="element-300">Nicolas Lehnert</p>
            <p data-id="element-301">Rheingasse 4</p>
            <p data-id="element-302">53113 Bonn</p>
          </div>
        </section>
        <section data-id="element-303">
          <h2 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-304">
            EU-Streitschlichtung
          </h2>
          <div className="space-y-2" data-id="element-305">
            <p data-id="element-306">
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:
            </p>
            <p data-id="element-307">
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-308">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p data-id="element-309">Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
          </div>
        </section>
        <section data-id="element-310">
          <h2 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-311">
            Verbraucher­streit­beilegung/Universal­schlichtungs­stelle
          </h2>
          <div className="space-y-2" data-id="element-312">
            <p data-id="element-313">
              Wir sind nicht bereit oder verpflichtet, an
              Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
              teilzunehmen.
            </p>
          </div>
        </section>
      </div>
    </motion.div>;
};
export default Impressum;